/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Contract version.
 */
export const UploadSkillContentPayloadSchemaVersion = {
  HookSkillContentV1: "hook.skill-content.v1",
} as const;
/**
 * Contract version.
 */
export type UploadSkillContentPayloadSchemaVersion = ClosedEnum<
  typeof UploadSkillContentPayloadSchemaVersion
>;

/**
 * Content for a skill manifest requested by a prior hook ingest response.
 */
export type UploadSkillContentPayload = {
  /**
   * Raw UTF-8 skill manifest content. The server rejects content whose UTF-8 encoding exceeds 65,536 bytes.
   */
  content: string;
  /**
   * Lowercase SHA-256 of the raw content.
   */
  rawSha256: string;
  /**
   * Contract version.
   */
  schemaVersion: UploadSkillContentPayloadSchemaVersion;
};

/** @internal */
export const UploadSkillContentPayloadSchemaVersion$outboundSchema:
  z.ZodMiniEnum<typeof UploadSkillContentPayloadSchemaVersion> = z.enum(
    UploadSkillContentPayloadSchemaVersion,
  );

/** @internal */
export type UploadSkillContentPayload$Outbound = {
  content: string;
  raw_sha256: string;
  schema_version: string;
};

/** @internal */
export const UploadSkillContentPayload$outboundSchema: z.ZodMiniType<
  UploadSkillContentPayload$Outbound,
  UploadSkillContentPayload
> = z.pipe(
  z.object({
    content: z.string(),
    rawSha256: z.string(),
    schemaVersion: UploadSkillContentPayloadSchemaVersion$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      rawSha256: "raw_sha256",
      schemaVersion: "schema_version",
    });
  }),
);

export function uploadSkillContentPayloadToJSON(
  uploadSkillContentPayload: UploadSkillContentPayload,
): string {
  return JSON.stringify(
    UploadSkillContentPayload$outboundSchema.parse(uploadSkillContentPayload),
  );
}
